import { OrderRequestSchema } from '../../types';
import { callExternalApi } from '../callExternalApi';

export const fetchOrderRequestSchemasApi = async () => {
  return await callExternalApi<OrderRequestSchema[]>({
    url: 'api/order_request_schema',
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
